import React from 'react'
import styled from 'styled-components'

const Container = styled.div `
  margin: 0px;
  padding: 0px;
`

const Page = ({ className, children }) => (
  <Container className={ className }>
    { children }
  </Container>
)

export { Page }
